import { reducer } from './cct_reducer';

export default reducer;
